var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCameraGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "19px",
    viewBox: "0 0 27 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCameraGreen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-colors-dark-mode",
    transform: "translate(-1137.000000, -183.000000)",
    fill: "#7EC34D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(18.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(641.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.412219,6.54902626 C504.281659,6.49963469 504.156113,6.47483493 504.035475,6.47483493 C503.764224,6.47483493 503.538462,6.56904284 503.357505,6.75693876 L497.285488,12.7242719 L497.285488,10.2750741 C497.285488,9.09731917 496.861091,8.09056306 496.012296,7.25428585 C495.163449,6.41811261 494.141665,6 492.946102,6 L482.339175,6 C481.143981,6 480.121881,6.41811261 479.272981,7.25428585 C478.424397,8.09056306 478,9.09731917 478,10.2750741 L478,20.7250819 C478,21.9027328 478.424397,22.9094369 479.273034,23.7456622 C480.121934,24.5818874 481.144034,25 482.339228,25 L492.946207,25 C494.141718,25 495.163554,24.5818874 496.012402,23.7456622 C496.861196,22.9094369 497.285594,21.9027848 497.285594,20.7250819 L497.285594,18.2608586 L503.357611,24.2430092 C503.538568,24.4308532 503.764329,24.5250091 504.03558,24.5250091 C504.156219,24.5250091 504.281765,24.5002613 504.412324,24.4509737 C504.804266,24.2826785 505,23.9908523 505,23.5752353 L505,7.4250247 C505,7.00919969 504.804108,6.71732153 504.412219,6.54902626 Z",
    id: "icCameraGreen"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraGreen);
export default __webpack_public_path__ + "static/media/icCameraGreen.97504beba498133e9b96313d70193677.svg";
export { ForwardRef as ReactComponent };